var render = function render(){var _vm=this,_c=_vm._self._c;return _c('site-events',{attrs:{"events":_vm.events,"pages":_vm.eventsPages,"count":_vm.eventsCount},on:{"refresh-request":_vm.refreshEvents,"download-request":_vm.downloadEvents}})
}
var staticRenderFns = []

export { render, staticRenderFns }